<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div class="calendar-area">
      <popup-header v-on:clickClose="closeModal()" />
      <v-row id="create" class="ma-0">
        <v-col cols="12" class="px-4 py-0">
          <!-- 1.캘린더 헤더 (일자선택) -->
          <v-sheet>
            <v-toolbar flat>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon color="grey"> mdi-chevron-left </v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-toolbar-title v-if="$refs.calendar" class="month-title">
                {{ title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon color="grey"> mdi-chevron-right </v-icon>
              </v-btn>
            </v-toolbar>
          </v-sheet>

          <!-- 2. 캘린더 내용 -->
          <v-sheet style="height: calc(100vh - 180px); position: relative">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              type="month"
              :events="events"
              :event-color="getEventColor"
              :event-text-color="getEventTextColor"
              :weekday-format="getDay"
              :month-format="getMonth"
              @change="updateRange"
              min-weeks="5"
              class="two-line"
            >
            </v-calendar>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
/* 캘린더 컴포넌트 */

import PopupHeader from '@/components/common/PopupHeader.vue';
import { mapGetters } from 'vuex';
import { getWorkScheduleTimeDayBysearchYm } from '@/api/workStatus';
import routerConstants from '@/const/routerConstants.js';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/locale/ko';
import dialogMixin from '@/mixins/dialogMixin.js';

dayjs.extend(isBetween);
dayjs.locale('ko');

export default {
  mixins: [dialogMixin],
  data: () => ({
    modalName: 'work_schedule_time',
    calendarDate: '',
    title: '', // 캘린더 타이틀
    events: [], // 캘린더 일정목록
    focus: '',

    dailyInOutTimeObj: {}, // 일별출퇴근시간
    detailObj: {}, // 일정상세

    // 일정추가버튼 관련
    fab: false,
    hover: false,
    right: true,
    bottom: true,

    // 근태 텍스트 컬러 (고정, '_attendanceChip.scss'참고)
    gntTextColorObj: {
      bcFFD49A: 'ff7936',
      bcFFE79A: 'ff9204',
      bcA6E5BA: '0fa941',
      bc9CCBFC: '087ef7',
      bcD7DADD: '505961',
    },
  }),
  props: {
    appInfoParam: Object,
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },

  computed: {
    ...mapGetters(['IS_IOS']),
    ...mapGetters('MENU', ['GET_APPL_MENU_USE_YN']),

    /* os별 dial bottom 추출 */
    dialBottomByOs() {
      return this.IS_IOS ? '112' : '94';
    },
  },

  methods: {
    /* 기간 이전이후 선택 */
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    /* 캘린더 포맷 - 요일, 월 */
    getDay(date) {
      const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
      return daysOfWeek[date.weekday];
    },
    getMonth(date) {
      const monthName = [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ];
      return monthName[date.month - 1];
    },

    /* 캘린더 일정 컬러 */
    getEventColor(event) {
      return event.color;
    },
    getEventTextColor(event) {
      return event.textColor;
    },

    /* 캘린더 변경이벤트 : 초기or기간변경시 -> 일정 및 캘린더타이틀 세팅 */
    updateRange({ start }) {
      // +. 공통 스피너 ON
      //this.$store.commit('SPINNER/ON_COMMON_SPINNER');

      // 1. 캘린더 타이틀 세팅 (format : 'YYYY년 MM월')
      const startDate = dayjs(start.date);
      this.title = startDate.format('YYYY년 MM월');
      this.calendarDate = startDate.format('YYYYMM');

      // 2. 월단위 캘린더 목록조회
      this.getPsnlCalendarMonList();
    },

    /* 일자 클릭이벤트 : 일정상세 모달 호출 */
    openDetailModal(param) {
      const paramDate = dayjs(param.date);

      // 0. 지난/다음달의 일자 클릭한 경우 즉시종료 (캘린더 6주 표기로 인한 방어로직)
      if (this.calendarDate !== paramDate.format('YYYYMM')) {
        return;
      }

      // 1. 클릭한 일자에 해당되는 근태현황을 추출
      const dailyEventList = this.events.filter(
        evt =>
          paramDate.isBetween(evt.start, evt.end, 'day', '[]') &&
          evt.gubun != 1,
      );

      // 2. 일정상세 모달로 전달할 파라미터 세팅
      this.detailObj = {
        dayTitle: paramDate.format('YYYY년 MM월 DD일(ddd)'),
        dailyInOutTime: this.dailyInOutTimeObj[`${param.date}`],
        dailyEventList,
      };

      // 3. 모달 오픈
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'calendar_detail');
    },

    /* 신청서 작성 화면이동 */
    goApplMenuList() {
      this.$router.push({ name: routerConstants.ApplicationMenu }); // 신청서메뉴페이지로 이동
    },

    /* 월단위 캘린더 목록조회 */
    async getPsnlCalendarMonList() {
      try {
        // 1. api 호출

        const response = await getWorkScheduleTimeDayBysearchYm({
          searchYm: this.calendarDate,
          applSeq: this.appInfoParam.applSeq,
        });

        const dataList = response.data.data;

        // 2. 초기화
        let event = [];
        this.dailyInOutTimeObj = {};

        // 3. 조회결과 추출
        dataList.forEach(item => {
          let textColor = '#FF5C5C';

          let backColor;

          if (item.holidayYn === 'Y') {
            backColor = '#FEE2E2'; // 기본 : 휴일컬러
          }

          if (item.bfTimeCd !== null && item.afTimeCd !== null) {
            backColor = '#fcf6a5'; // 변경데이터 : 컬러
          }

          let name;
          if (item.timeNm2===null) {
            name = item.timeNm;
          } else {
            name = item.timeNm2
          }

          if (item.holidayYn === 'Y') {
            name = item.holidayNm;
          }

          event.push({
            name: name,
            start:
              item.ymd.substring(0, 4) +
              '-' +
              item.ymd.substring(4, 6) +
              '-' +
              item.ymd.substring(6, 8),
            end:
              item.ymd.substring(0, 4) +
              '-' +
              item.ymd.substring(4, 6) +
              '-' +
              item.ymd.substring(6, 8),
            color: backColor,
            textColor: textColor,
            timed: true,
            applSeq: item.applSeq,
            gubun: item.gubun,
          });
        });

        // 4. 캘린더 일정 추가
        this.events = event;

        // +. 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
  },

  mounted() {
    //this.$refs.calendar.checkChange();
  },

  components: { PopupHeader },
};
</script>

<style>
.v-speed-dial--right {
  right: 24px !important;
}
/* .v-speed-dial--bottom {
  bottom: 94px !important;
} */

.v-calendar.two-line .v-event  .pl-1 {
  padding: 1px 4px !important;
  text-align: left;
  line-height: 1.6 !important;;
}

.v-calendar.two-line .v-event {
  font-size: 0.5625rem !important;
  cursor: pointer;
  border-radius: 3px !important;
  word-break: break-all !important;
  text-overflow: clip !important;
  white-space: normal !important;
  height: auto !important;
}
  /*height: 20px !important;
  line-height: 20px !important;*/

</style>
